export const EvosCoin = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="20" height="20" rx="10" fill="white" />
    <path
      d="M14 5.15385H10.5M14 14.8462H10.5M7 10V6.15385C7 5.60156 7.44772 5.15385 8 5.15385H10.5M7 10V13.8462C7 14.3984 7.44772 14.8462 8 14.8462H10.5M7 10H12.8333M10.5 5.15385V3M10.5 14.8462V17"
      stroke="#2BB747"
      stroke-width="1.5"
    />
  </svg>
);
